import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { changeMappedHeadStatus, fetchDepartments, fetchDesignations, fetchMappedHeads, fetchReimbursementHeads, fetchReimbursementMappedheads, fetchReimbursementSubheads, saveMappedHead, fetchReimbursementMappedsubheads } from "store/actions";
import CustomDatePicker from "common/CustomDatePicker";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { logDOM } from "@testing-library/react";
import { convertToInputDate } from "common/dateFormat/formatDate";

const MasterMapping = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    mappedheadslist,
    masterheads,
    mappedheads,
    departments,
    designations,
    mappedsubheads,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    mappedheadslist: state.ReimbursementMasterReducer?.mappedheadslist ?? [],
    mappedsubheads: state.ReimbursementMasterReducer?.mappedsubheads ?? [],
    masterheads: state.ReimbursementMasterReducer?.masterheads ?? [],
    mappedheads: state.ReimbursementMasterReducer?.mappedheads ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    designations: state.DesignationMaster?.designations ?? [],

    loading: state.ReimbursementMasterReducer?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading,
    error: state.ReimbursementMasterReducer?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error,
    success: state.ReimbursementMasterReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id;
    const userId = authUserDetails[0].user_id;
    dispatch(fetchReimbursementHeads(unitId, userId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchMappedHeads(unitId))
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchMappedHeads(authDetails?.unit_id));
      formik.resetForm();
      setIsEdit(false);
      setEditId(null);
    }
  }, [authDetails, success, dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const formik = useFormik({
    initialValues: {
      headsName: null,
      subHeadsName: null,
      department: null,
      designation: null,
      lowerLimit: "",
      upperLimit: "",
      fromDate: null,
      toDate: null,
      isAttach: false,
    },
    validationSchema: Yup.object({
      headsName: Yup.object().nullable().required("Heads Name is required"),
      subHeadsName: Yup.object().nullable().required("Subheads name is required"),
      department: Yup.object().nullable().required("Department is required"),
      designation: Yup.object().nullable().required("Designation is required"),
      lowerLimit: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : Number(originalValue)
        )
        .typeError("Lower Threshold must be a number")
        .min(0, "Lower Threshold cannot be negative")
        .required("Lower Threshold Limit is required"),

      upperLimit: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : Number(originalValue)
        )
        .typeError("Upper Threshold must be a number")
        .min(0, "Upper Threshold cannot be negative")
        .min(
          Yup.ref("lowerLimit"),
          "Upper Threshold must be greater than or equal to Lower Threshold"
        )
        .required("Upper Threshold Limit is required"),


      fromDate: Yup.date()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === "" || originalValue === null
            ? null
            : value
        )
        .typeError("Invalid date format")
        .required("From Date is required"),

      toDate: Yup.date()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === "" || originalValue === null
            ? null
            : value
        )
        .typeError("Invalid date format")
        .when("fromDate", (fromDate, schema) =>
          fromDate
            ? schema.min(fromDate, "To Date cannot be earlier than From Date")
            : schema
        )
        .required("To Date is required"),

    }),

    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("map_id", editId ? editId : 0);
      formData.append("head_id", values.headsName?.value);
      formData.append("subhead_id", values.subHeadsName.value);
      formData.append("department_id", values.department?.value);
      formData.append("designation_id", values.designation?.value);
      formData.append("lower_limit", values.lowerLimit);
      formData.append("upper_limit", values.upperLimit);
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("is_attach", values.isAttach ? 1 : 0);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      dispatch(saveMappedHead(formData));
    },
  });

  const handleEdit = (row) => {
    dispatch(fetchReimbursementMappedheads(authDetails?.unit_id, row.head_id));
    formik.setValues({
      headsName: { value: row.head_id, label: row.head_name },
      subHeadsName: { value: row.subhead_id, label: row.subheads_name },
      department: { value: row.department_id, label: row.department_name },
      designation: { value: row.designation_id, label: row.designation_name },
      lowerLimit: row.lower_limit,
      upperLimit: row.upper_limit,
      fromDate: convertToInputDate(row.from_date),
      toDate: convertToInputDate(row.to_date),
      isAttach: row.is_attachement === 1,
    });
    setIsEdit(true);
    setEditId(row.map_id);
  };

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => mappedheadslist.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    { Header: "Heads Name", accessor: "head_name" },
    { Header: "SubHeads Name", accessor: "subheads_name" },
    { Header: "Department", accessor: "department_name" },
    { Header: "Designation", accessor: "designation_name" },
    { Header: "Lower limit", accessor: "lower_limit" },
    { Header: "Upper limit", accessor: "upper_limit" },
    { Header: "From Date", accessor: "from_date" },
    { Header: "To Date", accessor: "to_date" },
    {
      Header: "IsAttach",
      accessor: "is_attachement",
      Cell: ({ value }) => (value === 1 ? "Yes" : "No"),
    },
    {
      Header: "Action",
      className: "action-col",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        const { b_active, map_id } = cellProps.row.original;
        const isActive = b_active === 1;
        // return (
        //   <div className="d-flex gap-3">
        //     <Link
        //       to="#"
        //       style={{ color: isActive ? "green" : "red" }}
        //       onClick={() => handleToggleStatus(map_id, isActive)}
        //     >
        //       <i
        //         className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
        //         id={`status-tooltip-${cellProps.row.id}`}
        //       />
        //       <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
        //         {isActive ? "Mark Inactive" : "Mark Active"}
        //       </UncontrolledTooltip>
        //     </Link>
        //     <Link
        //       to="#"
        //       className="text-success"
        //       onClick={() => handleEdit(cellProps.row.original)}
        //     >
        //       <i className="bx bxs-edit font-size-18" id="edittooltip" />
        //       <UncontrolledTooltip placement="top" target="edittooltip">
        //         Edit
        //       </UncontrolledTooltip>
        //     </Link>
        //   </div>
        // );
        return (
          <div className="d-flex gap-3">
            {/* Status Toggle */}
            <button
              type="button"
              className="btn btn-link p-0"
              style={{ color: isActive ? "green" : "red" }}
              onClick={() => handleToggleStatus(map_id, isActive)}
            >
              <i
                className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"
                  } font-size-18`}
              />
            </button>

            {/* Edit */}
            <button
              type="button"
              className="btn btn-link text-success p-0"
              onClick={() => handleEdit(cellProps.row.original)}
            >
              <i className="bx bxs-edit font-size-18" />
            </button>
          </div>
        );
      },
    },
  ];

  const handleToggleStatus = (map_id, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("map_id", map_id);
        formData.append("create_by", authDetails?.user_id);
        dispatch(changeMappedHeadStatus(formData));
      }
    });
  };

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };


  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "All unsaved changes will be lost.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        formik.resetForm();
        setIsEdit(false);
        setEditId(null);
      }
    });
  };


  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Reimbursement" breadcrumbItem="Master Mapping" />

        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col md="3">
                  <FormGroup>
                    <Label for="headsName">Heads Name <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="headsName"
                      options={(masterheads || []).map(emp => ({ value: emp.head_id, label: emp.head_name }))}
                      value={formik.values.headsName || null}
                      onChange={(selectedOption) => {
                        formik.setFieldValue("headsName", selectedOption);
                        formik.setFieldValue("subHeadsName", null);

                        dispatch({ type: "CLEAR_REIMBURSEMENT_SUBHEADS" });

                        if (selectedOption) {
                          dispatch(
                            fetchReimbursementMappedsubheads(
                              authDetails?.unit_id,
                              selectedOption.value // head_id
                            )
                          );
                        }
                      }}

                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.headsName && formik.errors.headsName && (
                      <div className="text-danger">{formik.errors.headsName}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="subHeadsName">Sub-Heads Name <span className="text-danger">*</span></Label>
                    {/* <Select
                      styles={SelectcustomStyles}
                      id="subHeadsName"
                      options={(mappedheads || []).map(emp => ({ value: emp.subhead_id, label: emp.subheads_name }))}
                      value={formik.values.subHeadsName || null}
                      onChange={(selectedOption) => formik.setFieldValue("subHeadsName", selectedOption)}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    /> */}
                    <Select
                      key={formik.values.headsName?.value || "no-head"}
                      id="subHeadsName"
                      options={(mappedsubheads || []).map(emp => ({
                        value: emp.subhead_id,
                        label: emp.subheads_name,
                      }))}

                      value={formik.values.subHeadsName}
                      onChange={(opt) => formik.setFieldValue("subHeadsName", opt)}
                      isDisabled={!formik.values.headsName}
                    />
                    {formik.touched.subHeadsName && formik.errors.subHeadsName && (
                      <div className="text-danger">{formik.errors.subHeadsName}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="department">Department <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="department"
                      options={(departments || []).map(emp => ({ value: emp.departmentId, label: emp.departmentname }))}
                      value={formik.values.department || null}
                      onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger">{formik.errors.department}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="designation">Designation <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="designation"
                      options={(designations || []).map(emp => ({ value: emp.desig_id, label: emp.designation }))}
                      value={formik.values.designation || null}
                      onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.designation && formik.errors.designation && (
                      <div className="text-danger">{formik.errors.designation}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="lowerLimit">Lower Threshold Limit <span className="text-danger">*</span></Label>
                    {/* <Input
                      id="lowerLimit"
                      name="lowerLimit"
                      type="number"
                      onChange={formik.handleChange}
                      value={formik.values.lowerLimit}
                      className={formik.touched.lowerLimit && formik.errors.lowerLimit ? "is-invalid" : ""}
                    /> */}
                    <Input
                      id="lowerLimit"
                      name="lowerLimit"
                      type="number"
                      min="0"
                      className={
                        formik.touched.lowerLimit && formik.errors.lowerLimit
                          ? "is-invalid"
                          : ""
                      }
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || Number(value) >= 0) {
                          formik.setFieldValue("lowerLimit", value);
                          formik.setFieldTouched("upperLimit", true);
                          formik.validateField("upperLimit");
                        }
                      }}

                      value={formik.values.lowerLimit}
                    />
                    {formik.touched.lowerLimit && formik.errors.lowerLimit && (
                      <div className="invalid-feedback">{formik.errors.lowerLimit}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="upperLimit">Upper Threshold Limit <span className="text-danger">*</span></Label>
                    {/* <Input
                      id="upperLimit"
                      name="upperLimit"
                      type="number"
                      onChange={formik.handleChange}
                      value={formik.values.upperLimit}
                      className={formik.touched.upperLimit && formik.errors.upperLimit ? "is-invalid" : ""}
                    /> */}
                    <Input
                      id="upperLimit"
                      name="upperLimit"
                      type="number"
                      min="0"
                      className={
                        formik.touched.upperLimit && formik.errors.upperLimit
                          ? "is-invalid"
                          : ""
                      }
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || Number(value) >= 0) {
                          formik.setFieldValue("upperLimit", value);
                        }
                      }}
                      value={formik.values.upperLimit}
                    />
                    {formik.touched.upperLimit && formik.errors.upperLimit && (
                      <div className="invalid-feedback">{formik.errors.upperLimit}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="fromDate">From Date<span className="text-danger">*</span></Label>
                    <CustomDatePicker
                      value={formik.values.fromDate}
                      onChange={(date) => formik.setFieldValue("fromDate", date)}
                      onBlur={() => formik.setFieldTouched("fromDate", true)}
                    />
                    {formik.touched.fromDate && formik.errors.fromDate && (
                      <div className="text-danger">{formik.errors.fromDate}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                    <CustomDatePicker
                      value={formik.values.toDate}
                      onChange={(date) => formik.setFieldValue("toDate", date)}
                      onBlur={() => formik.setFieldTouched("toDate", true)}
                    />
                    {formik.touched.toDate && formik.errors.toDate && (
                      <div className="text-danger">{formik.errors.toDate}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup check className="d-flex align-items-center gap-2 master-check">
                    <Input
                      id="isAttach"
                      name="isAttach"
                      type="checkbox"
                      onChange={(e) => formik.setFieldValue("isAttach", e.target.checked)}
                      checked={formik.values.isAttach}
                    />
                    <Label for="isAttach">Is Attachment</Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="text-end mob-center">
                  <Button type="submit" className="btn button-save me-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button
                    type="button"
                    onClick={handleCancel} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={mappedheadslist && mappedheadslist.length > 0 ? mappedheadslist : []}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default MasterMapping;
